import { ReactNode } from "react";

export default function ResponsiveSection({ children }: { children: ReactNode }) {
  return (
    <main className="flex-grow flex flex-col justify-center items-center text-center px-4 py-8 sm:p-8 max-w-screen-xl mx-auto w-full">
      {children}
    </main>
  );
}
